// extracted by mini-css-extract-plugin
export default {"container":"PromptListItem_container__Cef9P","root":"PromptListItem_root__giMLy","model":"PromptListItem_model__axQ3z","content":"PromptListItem_content__4uGNj"};